import {Directive, ElementRef, HostListener, Input,Component, OnInit, ViewChild } from '@angular/core';
import {UntypedFormBuilder,ValidationErrors, UntypedFormGroup, Validators,AbstractControl} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {MatSnackBar} from '@angular/material/snack-bar';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router,ActivatedRoute } from '@angular/router';
import {Servicio} from '../servicio/servicio';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Documento } from '../clase/documento';
@Component({
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css']
})
export class RecuperarComponent implements OnInit {
  editable1: boolean = false;
  editable2: boolean = false;
  editable3: boolean = false;
  completed1: boolean = false;
  completed2: boolean = false;
  completed3: boolean = false;
  isLinear = false;
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  tresFormGroup: UntypedFormGroup;
  color = 'primary';
  checked = false;
  disabled = false;
  codigo_cliente="";
  estado_apertura=true;
  documentos: Documento[] = [];

  cargar_info()
  {

    var w = window.open (this.servicio.url_global+"generacion_uso_clave_internet.pdf","winName","location=0,width=600,height=400");
      w.focus();
  }
  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }
  constructor(private el: ElementRef,private router:Router,private servicio:Servicio,private _snackBar: MatSnackBar,private ngxService: NgxUiLoaderService,private _formBuilder: UntypedFormBuilder) { }


crear_variable={};
tan={}; 
 onchange(e)
   {
     var data=e.value;
     this.tan=this.crear_variable[data];
    ///  alert(this.tan);
    
     
   //  console.log(this.tan);
   }
  ngOnInit() {




    var datos={};
    let token;
     //token=this.token();

  let _this=this;

    datos["id_dispositivo"] = "dasdasdasdasd";
    this.servicio.enviar("api/ws_creartokensimple",datos).pipe().subscribe(
      response=>{
          // console.log(response["token"]);

            sessionStorage.setItem("token",response["token"]);
           var datos1={};
           _this.servicio.enviar_seguro("api/ws_peclSeltipoidentidad",datos1,response["token"]).pipe().subscribe(
             datos=>{

              //console.log(datos["response"]);
                      datos["response"].forEach(element => {
                        _this.documentos.push(new Documento(element["TipoIdentidadID"],element["NomIdentidad"]));
                       // _this.selected = '01';
                          _this.documentos= _this.documentos.filter((element) => element.id =="01" || element.id =="05" );
                        _this.crear_variable[element["TipoIdentidadID"]]=element["NroCaracter"];
                   });      
             }  ,
               error => {
               }
           );











      }  ,
        error => {
        }
    );




    this.firstFormGroup = this._formBuilder.group({
      'documento':['',Validators.required],
      'numero_tarjeta': ['', Validators.required],
      'pin': ['', Validators.required],
      'num_documento': ['', Validators.required]
      
      
    });
    
    this.tresFormGroup = this._formBuilder.group({
      'clave_socio_linea': ['',[ Validators.required,Validators.pattern("(?=.*?[0-9])(?=.*?[a-z]).{8,}"),]],
    
      'clave_socio_linea_res':['',[Validators.required,Validators.minLength(6),
        this.matchValues('clave_socio_linea')
      
      ]]
    });
  }



  onChange(value: MatSlideToggleChange) {
    var estado=this.secondFormGroup.value["permiso"];
    if(estado){
        this.estado_apertura=false;
    }else{
     this.estado_apertura=true;
 
    }
   }
 validar_dos(stepper: MatStepper){
     if(!this.secondFormGroup.invalid){
       
         stepper.next(); 
     }
 }
 validar_tres(){
       if(!this.tresFormGroup.invalid){
          var _this=this;
         this.ngxService.start(); 
            var request={};
            var response={};
           // request["informacion"]= this.secondFormGroup.value;
            request["personal"]=this.tresFormGroup.value;
            request["codigo_cliente"]=this.codigo_cliente;
            request["token"]= _this.token;
            this.servicio.enviar_seguro("api/ws_recuperar_clave_cuenta",JSON.stringify(request),sessionStorage.getItem("token")).pipe().subscribe(
             response=>{
              
                  if(response["status"]==200){
                       if(response["response"][0]["rpt"]!="0"){
                         _this._snackBar.open(response["response"][0]["msg"],"", {
                           panelClass: ["blue1-snackbar"],
                           duration: 2* 1000,
                         
                         });
                         this.ngxService.stop();
                         this.router.navigate(['/inicio']);
                       }else{
 
                         _this._snackBar.open(response["response"][0]["msg"],"", {
                           panelClass: ["blue-snackbar"],
                           duration: 2* 1000,
                        
                         });
                         this.ngxService.stop();
                       }
 
                  }else{
                   _this._snackBar.open("ERROR DEL SERVIDOR","", {
                     panelClass: ["blue-snackbar"],
                     duration: 2* 1000,
                  
                   });
                   this.ngxService.stop();
                  }
             },
               error => {
               }
           );
       }
 }
 
 token:String="";
   validar_uno(stepper: MatStepper){
     var _this=this;
    if (!this.firstFormGroup.invalid) {
     this.ngxService.start(); 
      var request={};
      request= this.firstFormGroup.value;
      this.servicio.enviar_seguro("api/ws_validar_tarjeta_dni",request,sessionStorage.getItem("token")).pipe().subscribe(
       response=>{
        var data=response["response"];
        if(data["responseCode"]== "200"){
          if(data["rpt"]==1)
          {
            this.ngxService.stop();
            stepper.next(); 
                _this.codigo_cliente=data["cuenta"];
                _this.token=data["token_sesion"];
          }else{
            _this._snackBar.open("Documento de identidad, Número de tarjeta o clave son incorrectos","", {
              panelClass: ["blue-snackbar"],
              duration: 2* 1000,
            });
            this.ngxService.stop();
          }
        }
        if(data["responseCode"]== "401"){
         _this._snackBar.open("Documento de identidad, Número de tarjeta o clave son incorrectos","", {
           panelClass: ["blue-snackbar"],
           duration: 2* 1000,
         });
         this.ngxService.stop();
       }
       if(data["responseCode"]== "400"){
         _this._snackBar.open("Documento de identidad, Número de tarjeta o clave son incorrectos","", {
           panelClass: ["blue-snackbar"],
           duration: 2* 1000,
    
         });
         this.ngxService.stop();
       }
     }  ,
     error => {});
    }
   }
 
    matchValues(
     matchTo: string 
  ): (AbstractControl) => ValidationErrors | null {
     return (control: AbstractControl): ValidationErrors | null => {
       return !!control.parent &&
         !!control.parent.value &&
         control.value === control.parent.controls[matchTo].value
         ? null
         : { isMatching: false };
     };
 }

}
